import * as types from '../mutation-types'

// initial state
const state = {
  num: null
}

// getters
const getters = {
  messageNum: state => state.num
}

// actions
const actions = {
  getNewMessageNum ({ commit }, payload) {
    commit(types.GET_NEW_MESSAGE_NUM, payload)
  }
}

// mutations
const mutations = {
  [types.GET_NEW_MESSAGE_NUM] (state, payload) {
    state.num = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
